<template>
  <div id="list_wrap" class="absolute w-full text-center">
    <ul class="grid grid-cols-2 mx-auto gap-y-5 gap-x-5 w-11/12">
      <li
        class="w-full text-center m-auto rounded-xl"
        v-for="(item, index) in items"
        :key="`users_${index}`"
      >
        <div>
          <router-link
            :to="{ name: 'GalleryId', params: { galleryId: item.id } }"
          >
            {{ item.users.username }}
          </router-link>
        </div>
      </li>
    </ul>
    <base-pagination
      class="page"
      v-if="totalPages > 1"
      :total="totalItems"
      :loading="contentLoading"
      :currentPage="currentPage"
      :pageCount="totalPages"
      :perPage="pageSize"
      @change="fetch"
    />
  </div>
</template>

<script>
import BasePagination from "../components/core/BasePagination.vue";
import services from "../services";

export default {
  components: { BasePagination },
  name: "UserGalleryList",
  data() {
    return {
      items: [],
      pageSize: 10,
      currentPage: 1,
      totalItems: 0,
      totalPages: 0,
      contentLoading: true,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch(page = 1) {
      this.currentPage = page;
      this.contentLoading = true;
      const params = {
        page: this.currentPage,
        size: this.pageSize,
      };
      await services.galleryFindAll(params).then(
        (response) => {
          const { data } = response;
          this.items = data.items;
          this.totalItems = data.totalItems;
          this.totalPages = data.totalPages;
          this.contentLoading = false;
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
          this.items = [];
          this.totalItems = 0;
          this.totalPages = 0;
          this.contentLoading = false;
        }
      );
    },
  },
};
</script>

<style lang="css" scoped>
#list_wrap {
  height: 100%;
  width: 100%;
  z-index: 18;
  background: url("../assets/images/bg.png") no-repeat center;
}
/* #list_wrap ul {
  padding-top: 70px;
} */

#list_wrap li {
  height: 80px;
  background: url("../assets/images/gallery/box.png") no-repeat center;
}
#list_wrap li div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
#list_wrap li div a {
  display: block;
  width: 100%;
  padding: 20px 10px;
}
.page {
  position: fixed;
  left: 50%;
  bottom: 3.8rem;
  transform: translateX(-50%);
  color: #fff;
}
</style>